export const getPath = (category: string): string | undefined => {
  const categoryPaths: { [key: string]: string } = {
    Акції: 'sales',
    Елементи: 'batteries',
    'Готові комплекти': 'assembly',
    'FPV-дрони': 'batteries-for-fpv',
    Електротранспорт: 'batteries-for-transport',
    Іграшки: 'batteries-for-toys',
    Прилади: 'devices',
    'Витратні матеріали': 'materials',
    'Акумулятори 18650': 'batteries-18650',
    'Акумулятори 21700': 'batteries-21700',
  };

  return categoryPaths[category];
};
